import React, { CSSProperties } from 'react';
import { buttonStyles, panelStyles } from '../styles';

export const Button: React.FC<{
  onClick: () => void;
  color?: string;
  textColor?: string;
  children: React.ReactNode;
  variant?: 'default' | 'danger';
}> = ({ onClick, color, textColor, children, variant = 'default' }) => {
  const style = {
    ...buttonStyles.base,
    ...(variant === 'danger' ? buttonStyles.danger : buttonStyles.default),
    ...(color ? { background: color } : {}),
    ...(textColor ? { color: textColor } : {})
  };

  return (
    <button onClick={onClick} style={style}>
      {children}
    </button>
  );
};

export const Panel: React.FC<{
  title: string;
  onBack?: () => void;
  onClose: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
}> = ({ title, onBack, onClose, children, fullScreen }) => {
  const containerStyle = {
    ...panelStyles.base,
    ...(fullScreen ? panelStyles.fullScreen : panelStyles.default)
  } as CSSProperties;

  const headerStyle = (fullScreen ? panelStyles.headerFullScreen : panelStyles.header) as CSSProperties;
  const contentStyle = (fullScreen ? panelStyles.contentFullScreen : panelStyles.content) as CSSProperties;

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <div>
          <strong>{title}</strong>
        </div>
        <div>
          {onBack && <Button onClick={onBack}>Back</Button>}
          <Button onClick={onClose} variant="danger">
            Close
          </Button>
        </div>
      </div>
      <div style={contentStyle}>{children}</div>
    </div>
  );
};
